import { render, staticRenderFns } from "./TeacherItemM.vue?vue&type=template&id=43a2ef2e&scoped=true"
import script from "./TeacherItemM.vue?vue&type=script&lang=ts"
export * from "./TeacherItemM.vue?vue&type=script&lang=ts"
import style0 from "./TeacherItemM.vue?vue&type=style&index=0&id=43a2ef2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2ef2e",
  null
  
)

export default component.exports